// frontend/src/api/inspections.js
import { apiClient } from './index';

const inspectionsApi = {
  /**
   * Create a new inspection report (Admin/Technician only)
   * @param {Object} reportData 
   */
  createReport: async (reportData) => {
    return await apiClient.post('/inspections/', reportData);
  },

  /**
   * Get a report for a specific vehicle (Public)
   * @param {string} vehicleId 
   */
  getVehicleReport: async (vehicleId) => {
    return await apiClient.get(`/inspections/vehicle/${vehicleId}`);
  }
};

export { inspectionsApi };